


export const GetPermissionTreeData = (permissionData) => {
    let treeMainNode = GetChildNode(permissionData);
    return treeMainNode;
}

const GetChildNode = (permissionData) => {
    let treeData = [];
    let treeMainNode = permissionData

    if (treeMainNode) {
        treeMainNode.forEach(function (permissionKey) {
            let treeNode = {
                id: permissionKey.securityKeyId,
                name: permissionKey.securityKeyName,
                itemData: { ...permissionKey },
                isActive: false
            };

            treeData.push(treeNode);
        });
    }

    return treeData;

}


export const GetPermissionData = (permissionData) => {
    let permissionSettingData = [];
    permissionSettingData = GetChildPermissionData(permissionData)
    return permissionSettingData;
}

const GetChildPermissionData = (permissionList) => {
    let permissionData = [];

    if (permissionList) {

        permissionList.forEach(
            function (permissionItem) {
                // let permissionchildData =[];
                // if (permissionItem?.children.length > 0) {
                //      permissionchildData = GetChildPermissionData(permissionItem?.children);
                //      permissionData=permissionData.concat(permissionchildData);
                // }

                let item = {
                    roleId: permissionItem.itemData.roleId,
                    securityKeyId: permissionItem.itemData.securityKeyId,
                    securitySettingId: permissionItem.itemData.securitySettingId,
                    securityPermissionId: permissionItem.itemData.securityPermissionId,
                };
                permissionData.push(item);

            });
    }

    return permissionData;
};
